import { render, staticRenderFns } from "./organization-context.vue?vue&type=template&id=15e0bdd8&"
import script from "./organization-context.vue?vue&type=script&lang=js&"
export * from "./organization-context.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports